/* Afkar Plus — reviews: injects the big average + tabs + initials into the Judge.me widget once it has rendered (BeyondADS, 23 Sep 2026) */
(function () {
  'use strict';
  if (window.__afrLoaded) return;
  window.__afrLoaded = true;

  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.6l2.9 6.1 6.7.8-4.9 4.6 1.3 6.6L12 17.4l-6 3.3 1.3-6.6L2.4 9.5l6.7-.8z"/></svg>';

  function cfg(key, fallback) {
    var head = document.querySelector('[data-afr-head]');
    var v = head && head.getAttribute('data-' + key);
    return v || fallback;
  }

  function stars(avg) {
    var out = '<span class="afr-score__stars" aria-hidden="true"><svg width="0" height="0" style="position:absolute"><defs><linearGradient id="afr-half"><stop offset="50%" stop-color="#e31c63"/><stop offset="50%" stop-color="#e3e3e3"/></linearGradient></defs></svg>';
    for (var i = 1; i <= 5; i++) {
      var cls = avg >= i - 0.25 ? '' : (avg >= i - 0.75 ? ' class="is-half"' : ' class="is-off"');
      out += STAR.replace('<svg', '<svg' + cls);
    }
    return out + '</span>';
  }

  function initials(name) {
    var parts = (name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '·';
    var a = parts[0].charAt(0), b = parts.length > 1 ? parts[parts.length - 1].charAt(0) : parts[0].charAt(1) || '';
    return (a + b).toUpperCase();
  }

  function decorateReviews(w) {
    Array.prototype.forEach.call(w.querySelectorAll('.jdgm-rev'), function (rev) {
      if (rev.querySelector('.jdgm-rev__icon[data-initials]')) return;
      var icon = rev.querySelector('.jdgm-rev__icon');
      var author = rev.querySelector('.jdgm-rev__author');
      if (icon) icon.setAttribute('data-initials', initials(author ? author.textContent : ''));
      var wrap = rev.querySelector('.jdgm-rev__author-wrapper');
      if (wrap) wrap.setAttribute('data-status', rev.getAttribute('data-verified-buyer') === 'true' ? cfg('verified', 'Verified buyer') : cfg('unverified', 'Customer'));
    });
  }

  function setup(w) {
    /* Judge.me re-renders its widget after loading, so everything here is idempotent: inject only what is missing */
    var row = w.querySelector('.jdgm-row-stars');
    var avg = parseFloat(w.getAttribute('data-average-rating')) || 0;
    if (row && !row.querySelector('.afr-score')) {
      var score = document.createElement('div');
      score.className = 'afr-score';
      score.innerHTML = '<span class="afr-score__num">' + (avg ? avg.toFixed(1) : '–') + '</span>' + stars(avg) + '<span class="afr-score__based">' + cfg('based', 'Based on verified purchases') + '</span>';
      row.insertBefore(score, row.firstChild);
    }

    var write = w.querySelector('.jdgm-write-rev-link');
    if (write && !write.getAttribute('data-afr')) { write.setAttribute('data-afr', '1'); if (write.textContent !== cfg('write', 'Write a review')) write.textContent = cfg('write', 'Write a review'); }

    var sel = w.querySelector('.jdgm-sort-dropdown');
    var sortWrap = w.querySelector('.jdgm-rev-widg__sort-wrapper');
    if (sel) {
      var recent = sel.querySelector('option[value="most-recent"]');
      var newest = cfg('newest', 'Newest first');
      if (recent && recent.textContent !== newest) recent.textContent = newest; /* guarded: a write here re-fires the observer */
    }
    if (sel && sortWrap && !sortWrap.querySelector('.afr-tab')) {
      var hasPics = !!sel.querySelector('option[value="with-pictures"]');
      var tabs = [['most-recent', cfg('all', 'All reviews')]];
      if (hasPics) tabs.push(['with-pictures', cfg('photos', 'With photos')]);
      tabs.forEach(function (t, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'afr-tab' + ((i === 0 && sel.value === 'most-recent') || sel.value === t[0] ? ' is-active' : '');
        b.setAttribute('data-afr-sort', t[0]);
        b.textContent = t[1];
        sortWrap.appendChild(b);
      });
    }
    if (sortWrap && !sortWrap.getAttribute('data-afr')) {
      sortWrap.setAttribute('data-afr', '1');
      sortWrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-afr-sort]');
        var s = sortWrap.querySelector('.jdgm-sort-dropdown');
        if (!b || !s) return;
        s.value = b.getAttribute('data-afr-sort');
        s.dispatchEvent(new Event('change', { bubbles: true }));
        Array.prototype.forEach.call(sortWrap.querySelectorAll('.afr-tab'), function (x) { x.classList.toggle('is-active', x === b); });
      });
      sortWrap.addEventListener('change', function () {
        var s = sortWrap.querySelector('.jdgm-sort-dropdown');
        if (!s) return;
        Array.prototype.forEach.call(sortWrap.querySelectorAll('.afr-tab'), function (x) { x.classList.toggle('is-active', x.getAttribute('data-afr-sort') === s.value); });
      });
    }

    decorateReviews(w);
  }

  function scan() {
    var w = document.querySelector('.jdgm-rev-widg');
    if (w && w.querySelector('.jdgm-rev-widg__header')) setup(w);
  }

  var queued = false;
  function scheduleScan() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }
  function boot() {
    scan();
    var mo = new MutationObserver(function (muts) {
      /* ignore mutations we caused ourselves (inside the widget header / sort row) */
      for (var i = 0; i < muts.length; i++) {
        var tgt = muts[i].target;
        if (tgt && tgt.closest && (tgt.closest('.afr-score') || tgt.closest('.afr-tab'))) continue;
        scheduleScan();
        return;
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(scan, 1500);
    setTimeout(scan, 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
